import React from "react";
import { Helmet } from 'react-helmet';
import HomeMain from '../components/HomeMain';
import HomeContent from '../components/HomeContent';
import TrendingStyles from '../components/TrendingStyles';
import WellCrafting from '../components/WellCrafting';
import OurServices from '../components/OurServices';
import WeReOpen from '../components/WeReOpen';
import MarqueeBtm from '../components/MarqueeBtm';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>THE CUTTING BAR</title>
            </Helmet>
            <HomeMain />
            <HomeContent />
            <TrendingStyles />
            <WellCrafting />
            <OurServices />
            <WeReOpen />
            <MarqueeBtm />
        </>
    );
}

export default Home;
